import moment from 'moment';

export const today = moment().format('YYYY-MM-DD');
export const oneWeekAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
export const initialDate = moment('20190101', 'YYYYMMDD').format('YYYY-MM-DD');
export const threeMonthsAgo = moment().subtract(3, 'month').format('YYYY-MM-DD');

export const oneWeekAgoAtMidnight = moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
export const midnight = moment().endOf('day').add(1, 'minutes').format('YYYY-MM-DD HH:mm:00');
